import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Article } from './pages/Article';
import { Write } from './pages/Write';
import { Edit } from './pages/Edit';
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/Login';
import { AuthCallback } from './pages/AuthCallback';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Tag } from './pages/Tag';
import { useAuthStore } from './stores/auth';
import { useDraftStore } from './stores/draft';
// Import theme store to ensure it initializes and applies theme
import './stores/theme';

function App() {
  const { fetchUser, isLoading } = useAuthStore();
  const clearOldDrafts = useDraftStore((state) => state.clearOldDrafts);

  useEffect(() => {
    fetchUser();
    clearOldDrafts();
  }, [fetchUser, clearOldDrafts]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner w-8 h-8" />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="article/:slug" element={<Article />} />
          <Route path="write" element={<Write />} />
          <Route path="edit/:id" element={<Edit />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="login" element={<Login />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="tag/:tagName" element={<Tag />} />
        </Route>
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
